export default {"src":"/_next/static/media/eur.7ee11fc4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};